var PriceDtoFactory = /** @class */ (function () {
    function PriceDtoFactory() {
    }
    PriceDtoFactory.fromOfferingDto = function (offeringDto) {
        return {
            currency: offeringDto.payment.currency,
            price: offeringDto.payment.price,
            isFree: offeringDto.payment.isFree,
            priceText: offeringDto.payment.priceText,
            minCharge: offeringDto.payment.minCharge,
            paymentType: offeringDto.payment.paymentType,
            displayTextForPlan: offeringDto.pricingPlanInfo
                ? offeringDto.pricingPlanInfo.displayText
                : '',
        };
    };
    return PriceDtoFactory;
}());
export { PriceDtoFactory };
var PriceUtils = /** @class */ (function () {
    function PriceUtils() {
    }
    PriceUtils.getFractionDigits = function (price) {
        return price % 1 === 0 ? 0 : 2;
    };
    return PriceUtils;
}());
export { PriceUtils };
//# sourceMappingURL=price-dto-factory.js.map